// Insert Username with API call, and define sitefinityUserRoles
$(() => {
    $.get("/customapi/User/GetCurrentUser", function (user) {
        if (user) {
            $(".js-user-menu").removeClass("d-none");
        }
        window.sitefinityUserRoles = (user?.Roles ?? []).join("|");
        $(".js-menu-display-name").html(user?.FullName);
    });
});